import React from "react"
import styled from "styled-components"
import { Container, H2, P, AbsoluteImg, ButtonLink } from "../general/GeneralStyles"
import SearchBar from "../general/SearchBar"

const Banner = styled.div`
  background: ${props => props.theme.primaryAccentBg};
  margin-top: 75px;
  padding: 59px 0 48px 0;
  position: relative;

  @media (max-width: ${props => props.theme.extraLargeBreakpoint}) {
    padding: 45px 150px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding: 45px;

    ${AbsoluteImg} {
      display: none;
    }
  }

`

const RightBP = styled(AbsoluteImg)`
  right: 0;
  top: 0;
  z-index: 1;
`

const LeftBP = styled(AbsoluteImg)`
  left: 0;
  top: 0;
  z-index: 1;
  transform: scaleX(-1);
`

const SearchCTA = props => {
  return (
    <Banner>
      {/* Absolute Images */}
      <RightBP src="/images/absolute/backpack.png" alt="backpack" />
      <LeftBP src="/images/absolute/backpack.png" alt="backpack" />
      {/* End Absolute Images */}
      <Container>
        <H2>Let’s Get Started With Your School</H2>
        <P>We can ship products to your school or to your home address.</P>
        <ButtonLink to="sign-up">Create an Account</ButtonLink>
        {/* <SearchBar placeholder="Type in your location, zipcode, school name(?)" /> */}
      </Container>
    </Banner>
  )
}

export default SearchCTA
